import { Box, Button, Container, Divider, Grid, Stack, Typography, useTheme } from '@mui/material';
import MemoryIcon from '@mui/icons-material/Memory';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Link as RouteLink } from 'react-router-dom';
import { useSettings } from '@/app/contexts/SettingContext';

const columns = [
  // ['Company', 'About', 'Quality', 'Careers', 'Contact'],
  ['Services', 'PCB Design', 'Manufacturing', 'Assembly', 'Testing'],
  // ['Quick Links', 'Capabilities', 'Industries', 'Academy', 'Track Order'],
];

const socialLinks = [
  {
    "platform": "LinkedIn",
    "key": "ln",
    "icon": <LinkedInIcon/>,
    "link": "https://www.linkedin.com/company/crazymodifier-enterprises/"
  },
  {
    "platform": "Facebook",
    "key": "fb",
    "icon": <FacebookIcon/>,
    "link": "https://facebook.com/crazymodifierenterprises"
  },
]

export const Footer = () => {
  const settings = useSettings();
  const theme = useTheme();

  return (
    <Box component="footer" sx={{ bgcolor: 'background.default', color: 'text.primary', borderTop: `1px solid ${theme.palette.divider}` }}>
      <Container maxWidth="lg" sx={{ py: { xs: 5, md: 7 } }}>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Stack direction="row" spacing={1.2} sx={{ alignItems: 'center' }}>
              <Box 
                component="img"
                src="/img/crazymodifier-enterprises-logo.png"
                alt="Example"
                sx={{
                  width: 70,
                  height: 'auto',
                  mr: 1
                }}/>
              <Typography variant="h3" sx={{fontWeight:600}}>{settings?.site_name || 'CrazyModifier Enterprises'}</Typography>
            </Stack>
            <Typography sx={{ color: 'text.secondary', mt: 2, lineHeight: 1.8 }}>
              Accelerate your product journey with reliable PCB manufacturing and assembly. From prototypes to mass production, we provide component sourcing, SMT assembly, testing, and turnkey PCBA solutions —all backed by quality-driven processes and responsive engineering support.
            </Typography>
            <Stack direction="row" spacing={1.2} sx={{ mt: 3 }}>
              {socialLinks.map((item) => (
                

                <Button
                  component={RouteLink}
                  target='_blank'
                  to={item.link}
                  key={item.key}
                  variant="outlined"
                  aria-label={item.platform}
                  sx={{
                    minWidth: 42,
                    width: 42,
                    height: 42,
                    color: 'text.primary',
                    borderColor: 'divider',
                  }}
                >
                  {item.icon}
                </Button>
              ))}
            </Stack>
          </Grid>
          {columns.map(([title, ...links]) => (
            <Grid size={{ xs: 6, sm: 3, md: 3 }} key={title}>
              <Typography variant="subtitle2" sx={{ color: 'primary.main', fontWeight: 900, mb: 1.5 }}>
                {title}
              </Typography>
              <Stack spacing={1}>
                {links.map((link) => (
                  <Typography
                    component="a"
                    href={`#${link.toLowerCase().replace(/ /g, '-')}`}
                    key={link}
                    sx={{ color: 'text.secondary', textDecoration: 'none', '&:hover': { color: 'text.primary' } }}
                  >
                    {link}
                  </Typography>
                ))}
              </Stack>
            </Grid>
          ))}
          <Grid size={{ xs: 12, sm: 8, md: 3 }}>
            <Typography variant="subtitle2" sx={{ color: 'primary.main', fontWeight: 900, mb: 1.5 }}>
              Contact
            </Typography>
            <Stack spacing={1} sx={{ color: 'text.secondary' }}>
              <Typography>info@crazymodifier.com</Typography>
              <Typography>+91-8604026123</Typography>
              <Typography>+91-8115754525</Typography>
              {/* <Typography>Global shipping support</Typography> */}
            </Stack>
          </Grid>
        </Grid>
        <Divider sx={{ borderColor: 'divider', my: 4 }} />
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ justifyContent: 'space-between' }}>
          <Typography sx={{ color: 'text.secondary' }}>
            &copy; {new Date().getFullYear()} CrazyModifier Enterprises. All rights reserved.
          </Typography>
          {/* <Button component={RouteLink} to="/auth/login" sx={{ color: 'primary.main', alignSelf: { xs: 'flex-start', sm: 'center' } }}>
            Get Quote
          </Button> */}
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
